// initial state
const state = {
  types: {
    info: '文字题',
    text: '填空题',
    multitext: '多项填空题',
    select: '单选题',
    multiselect: '多选题',
    imageMultiselect: '图片多选题',
  },
  focusQuestionIndex: null,
  focusOptionIndex: null,
  evidenceType: [
    {label: '照片', value: 'photo'},
    {label: '二维码', value: 'qrcode'},
    {label: '视频', value: 'video'},
    {label: '录音', value: 'record'},
  ],
  evidenceQuality: [
    {label: '低品质', value: '1'},
    {label: '中品质', value: '2'},
    {label: '高品质', value: '3'},
    {label: '极高品质', value: '4'},
  ],
  inputType: [
    {label: '文本', value: 'text'},
    {label: '数字(整数)', value: 'numberInt'},
    {label: '数字(浮点数)', value: 'numberFloat'},
    {label: '日期', value: 'date'},
  ],
  clarity: [
    {label: '不检测', value: '0'},
    {label: '低品质', value: '0.2'},
    {label: '中品质', value: '0.4'},
    {label: '高品质', value: '0.6'},
    {label: '极高品质', value: '1'},
  ],
  imageRecognitionType: [
    {label: '近景', value: '1'},
    {label: '货架（正面）', value: '2'},
    {label: '货架（倾斜）', value: '3'},
  ],
  takePhotoAuxiliaryLineType: [
    {label: '未开启', value: 0},
    {label: '地堆', value: 1},
    {label: '包柱', value: 2},
    {label: '端架', value: 3},
    {label: '主货架', value: 4},
    {label: '立柜', value: 5},
  ],
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  setFocusIndex (state, {questionIndex, optionIndex}) {
    state.focusQuestionIndex = questionIndex
    state.focusOptionIndex = optionIndex
  },
}

export const stepTemplate = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/step-template/step-template.store.js